import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { getAvailabilityFromRule } from 'components/event_type_edit/utils/get_availability_from_rule';
import { CalendarViewControl } from '../calendar_view_control';
import { MoreOptions } from './more_options';
import { SchedulesDropdown } from './schedules_dropdown';
import { useActiveSchedule } from './use_active_schedule';
import { PanelContentHeader } from '../../../../styles';
import { useAvailabilitySidePanelActions } from '../availability_side_panel';
const headerPartCss = "hvwsfxv";
const HeaderPart = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerPartCss, props.className)} />;
});
export const ScheduleControls = ({
  formPath,
  isLocked,
  isReadOnly
}) => {
  const isDesktopUp = useDeviceType('isDesktopUp');
  const [{
    value
  }, _, {
    setValue
  }] = useFormField({
    name: formPath
  });
  const {
    userId,
    ownerAvailabilityRules
  } = value;
  const primaryRuleId = ownerAvailabilityRules?.primaryRuleId || ownerAvailabilityRules?.primary_rule_id;
  const primarySchedule = (ownerAvailabilityRules?.rules || []).find(({
    id
  }) => id === primaryRuleId);
  const {
    activeScheduleName
  } = useActiveSchedule({
    formPath
  });
  const {
    toggleAvailabilitySidePanel
  } = useAvailabilitySidePanelActions();
  const {
    usingCustomHours
  } = value;
  const handleRollbackToDefault = useCallback(() => {
    if (!primarySchedule) {
      return;
    }
    setValue({
      ...value,
      usingCustomHours: false,
      usingSecondarySchedule: true,
      activeAvailabilityRuleId: primarySchedule.id,
      ...getAvailabilityFromRule(primarySchedule)
    });
  }, [primarySchedule, setValue, value]);
  const isReadOnlyState = isLocked || isReadOnly;
  const showControls = !isReadOnlyState && usingCustomHours;
  const handleOpenCalendar = () => toggleAvailabilitySidePanel({
    formPath,
    format: 'calendar'
  });
  return <PanelContentHeader withActions>
      <HeaderPart>
        <BodyText size="medium" weight="bold">
          {I18n.t('publisher.event_type_editor.sections.availability.schedule.title')}
          {': '}
        </BodyText>
        {isReadOnlyState ? <BodyText size="medium">{activeScheduleName}</BodyText> : <SchedulesDropdown formPath={formPath} />}
      </HeaderPart>
      {showControls && <HeaderPart>
          {isDesktopUp && <CalendarViewControl onClick={handleOpenCalendar} />}
          <MoreOptions handleRollbackToDefault={handleRollbackToDefault} userId={userId} />
        </HeaderPart>}
    </PanelContentHeader>;
};

require("./schedule_controls.wyw-in-js.css!=!../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./schedule_controls.js");